import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { deleteEvent, getEventList } from 'app/api/event';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import Message from 'app/utils/Message';
import { dataformatChangesYearToDate } from 'app/utils/Parsers';
import Toast from 'app/utils/Toast';
const useEventManagement = () => {
  const [isdeleteFiltering, setIsdeleteFiltering] = useState(false); // New state to track filtering
  const navigate = useNavigate();
  const sectionObj = {
    sectionTitle: 'Event Mangement',
    searchObj: {
      keys: ['name', 'mallName'],
      placeholder: 'Search by Name, Mall name',
      searchType: 'server',

      handleSearch: (e) => {
        console.log('Handle search: ', e);
        //  inputChangeHandler(e);
      },
    },
    buttons: [
      {
        customclassName: '',
        imgTrue: true,
        title: APP_CONSTANTS.CREATE_EVENT_TAG,
        handleBtnClick: (e) => {
          navigate(`${APP_CONSTANTS.CREATE_EVENT}`);
        },
      },
    ],
  };

  const [pageCount, setPageCount] = useState(1);
  const [pageLoading, setPageLoading] = useState(false);
  const currentPage = 1;
  const dataPerPage = 10;
  const [filteredData, setFilteredData] = useState([]);
  const [totalNumber, setTotalNumber] = useState(0);

  // Function to fetch data from the server based on current page and search value
  const fetchEventData = useCallback(
    async (page, searchValue = '') => {
      setPageLoading(true);
      try {
        const response = await getEventList({
          page,
          limit: dataPerPage,
          search: searchValue,
        }); // Pass searchValue to API call
        if (response?.responseCode === 200) {
          const dataArr = response?.data?.eventsData || [];
          const newArray = dataArr.map((item) => ({
            ...item,
            mallName: item?.mallId?.mallName,
            timing: `${item?.startTime}-${item?.endTime}`,
            startDate: dataformatChangesYearToDate(item?.startDate),
            endDate: dataformatChangesYearToDate(item?.endDate),
          }));
          setFilteredData(newArray);

          const totalCount = response?.data?.count || 0;
          const tempcount = Math.ceil(totalCount / dataPerPage);
          setTotalNumber(totalCount);
          setPageCount(tempcount);
          setIsdeleteFiltering(false);
        } else {
          Toast.error(
            response?.response?.message || Message.Error.COMMON_MESSAGE
          );
        }
      } catch (error) {
        Toast.error(Message.Error.COMMON_MESSAGE);
      } finally {
        setPageLoading(false);
      }
    },
    [dataPerPage]
  );
  const callServiePublishOrUnpublishAPI = async (data) => {
    setPageLoading(true);
    if (data && data?.id) {
      let responseObj = await deleteEvent(data?.id);
      setPageLoading(false);
      setIsdeleteFiltering(true);
      if (responseObj?.responseCode === 200) {
        // loadNames();

        Toast.success('Event Deleted Successfully');

        // setRefresh(!refresh);
      }
    } else {
      Toast.error('Failed to delete');
    }
  };

  const handleDelete = (data) => {
    confirmAlert({
      title: '',
      message: `Are you sure you want to Delete ${data?.name} this event?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            //  setToggled(!toggled);
            callServiePublishOrUnpublishAPI(data);
          },
        },
        {
          label: 'No',
        },
      ],
      overlayClassName: 'overlay-custom-class-name',
    });
  };
  function handleEdit(data) {
    navigate(`/event/edit/:${data.id}`, {
      state: {
        ...data,
      },
    });
  }
  // ------------------------------------------------

  return {
    handleDelete,
    pageLoading,
    currentPage,
    dataPerPage,
    pageCount,
    navigate,
    handleEdit,
    sectionObj,
    totalNumber,
    filteredData,
    fetchEventData,
    isdeleteFiltering,
  };
};

export default useEventManagement;
